import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format confidence score
export function formatConfidence(confidence) {
  if (confidence === null || confidence === undefined) return 'N/A';
  return `${(confidence * 100).toFixed(1)}%`;
}

// Get confidence class
export function getConfidenceClass(confidence) {
  if (confidence === null || confidence === undefined) return 'confidence-warning';
  if (confidence >= 0.95) return 'confidence-excellent';
  if (confidence >= 0.80) return 'confidence-good';
  if (confidence >= 0.50) return 'confidence-warning';
  return 'confidence-critical';
}

// Get confidence color for progress bar
export function getConfidenceColor(confidence) {
  if (confidence === null || confidence === undefined) return 'bg-amber-500';
  if (confidence >= 0.95) return 'bg-green-600';
  if (confidence >= 0.80) return 'bg-emerald-500';
  if (confidence >= 0.50) return 'bg-amber-500';
  return 'bg-red-500';
}

// Get priority badge class
export function getPriorityClass(priority) {
  if (!priority) return 'priority-standard';
  const p = priority.toLowerCase();
  if (p === 'critical') return 'priority-critical';
  if (p === 'high') return 'priority-high';
  return 'priority-standard';
}

// Get status badge class
export function getStatusClass(status) {
  if (!status) return 'status-uploaded';
  const s = status.toLowerCase();
  if (s === 'processing') return 'status-processing';
  if (s === 'complete') return 'status-complete';
  if (s === 'failed') return 'status-failed';
  return 'status-uploaded';
}

// Format currency
export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return '$0.00';
  return `$${parseFloat(amount).toFixed(2)}`;
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return dateString;
  }
}

// Format relative time
export function formatRelativeTime(dateString) {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  } catch {
    return dateString;
  }
}
